export const ACTUALIZE_CART_API_DETAIL = {
  notFound: 'Not found',
} as const

export const ACTUALIZE_CART_VALIDATION_LOC = {
  productId: 'product_id',
} as const
